/* eslint-disable */

import { Directive, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, Renderer2 } from '@angular/core';
import { AcceptedFile } from '../dropped-files/accepted-file';
import { DropZoneStyle } from '../utilities/drop-zone-style';
import { FileState } from '../utilities/file-state';
import { RejectedFile } from '../dropped-files/rejected-file';
import { RejectionReasons } from '../properties/rejection-reasons';

// Directive to support dragging and dropping and element onto a div
@Directive({
    selector: '[FileDrop]' // eslint-disable-line @angular-eslint/directive-selector
    ,
    standalone: true
})

export class FileDropDirective implements OnInit {
  @Output()
  public ng2FileDropHoverStart: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  public ng2FileDropHoverEnd: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  public ng2FileDropFileAccepted: EventEmitter<AcceptedFile> = new EventEmitter<AcceptedFile>();
  @Output()
  public ng2FileDropFileRejected: EventEmitter<RejectedFile> = new EventEmitter<RejectedFile>();

  @Input()
  public ng2FileDropSupportedFileTypes: string[];
  @Input()
  public ng2FileDropMaximumSizeBytes: number;
  @Input()
  public ng2FileDropDisableStyles: boolean;
  @Input()
  public maxFiles = 0;

  // Keep track of our dropped files
  private fileService: FileState = new FileState();
  private dropZoneStyle: DropZoneStyle = null;

  // Constructor requires an element reference that instantiated this directive
  public constructor(private element: ElementRef, private renderer: Renderer2) { }

  // Initialisation
  public ngOnInit() {
    // Set our properties
    this.fileService.setExpectedFileProperties(this.ng2FileDropSupportedFileTypes, this.ng2FileDropMaximumSizeBytes);
    if (this.ng2FileDropDisableStyles !== true) {
      this.dropZoneStyle = new DropZoneStyle();
    }
  }

  // Called when the element has content dragged over
  @HostListener('document:dragover', ['$event'])
  public onDragOver(event: Event): void {
    // If we're already in the on-drag, don't bother with this
    if (this.fileService.currentFile === null) {
      // Get the object being dragged and reference it as a copy action
      this.fileService.currentFile = this.getDataTransferObject(event);
      if (this.fileService.currentFile === null) {
        return;
      }

      // Let the client know
      this.ng2FileDropHoverStart.emit();
      if (this.dropZoneStyle !== null) {
        // this.dropZoneStyle.onHoverStart();
      }
    }
    // Don't propagate
    this.preventAndStopEventPropagation(event);
  }

  // Called when the element has dragged content leave
  @HostListener('document:dragleave', ['$event'])
  public onDragLeave(event: Event): void {
    // Only bother if we have a file
    if (this.fileService.currentFile !== null) {
      // Finished with the file
      this.fileService.currentFile = null;
      if (event.currentTarget === (this as any).element[0]) {
        return;
      }

      // Let the client know
      this.ng2FileDropHoverEnd.emit();
      if (this.dropZoneStyle !== null) {
        // this.dropZoneStyle.onHoverEnd();
      }
    }
    // Don't let it continue
    this.preventAndStopEventPropagation(event);
  }

  @HostListener('change', ['$event'])
  public onChange(event: Event): void {
    this.fileService.currentFile = event.target;

    this.getAndEmitFiles();
  }

  // Called when the element has content dropped
  @HostListener('document:drop', ['$event'])
  public onDrop(event: Event): void {

    // Only bother if we have a file
    if (this.fileService.currentFile !== null) {

      // Let the client know
      this.ng2FileDropHoverEnd.emit();
      if (this.dropZoneStyle !== null) {
        // this.dropZoneStyle.onHoverEnd();
      }

      // Update our data
      this.fileService.currentFile = this.getDataTransferObject(event);

      this.getAndEmitFiles();

    }

    // Don't let it continue
    this.preventAndStopEventPropagation(event);
  }

  private getAndEmitFiles(){
    // Get the file
    const filesData: File[] = this.fileService.getFilesData();
    if (filesData.length > this.maxFiles) {
      this.ng2FileDropFileRejected.emit(new RejectedFile(null, RejectionReasons.FilesNumber));
      if (this.dropZoneStyle !== null) {
        this.dropZoneStyle.onFileRejected();
      }
    } else {
      for (let i = 0; i < filesData.length; i++) {
        // Check if our file is valid or not
        const rejectionReason: RejectionReasons = this.fileService.isFileValid(i);

        if (rejectionReason === RejectionReasons.None) {
          this.ng2FileDropFileAccepted.emit(new AcceptedFile(filesData[i]));
          if (this.dropZoneStyle !== null) {
            this.dropZoneStyle.onFileAccepted();
          }
        } else {
          this.ng2FileDropFileRejected.emit(new RejectedFile(filesData[i], rejectionReason));
          if (this.dropZoneStyle !== null) {
            this.dropZoneStyle.onFileRejected();
          }
        }
      }
    }
    // Finished with the file
    this.fileService.currentFile = null;
  }

  // Stops the drag/drop events propagating
  private preventAndStopEventPropagation(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
  }

  // Returns the file dragged into the directive
  private getDataTransferObject(event: Event | any): DataTransfer {
    return event.dataTransfer ? event.dataTransfer : event.originalEvent.dataTransfer;
  }
}
